module.exports = __webpack_public_path__ + "media/src/images/process_arrow-55780148fcb07da4b9779d3780d5a505.png";